/**
 * Product branding — the one place the product's public name and strapline
 * live, so the landing page, the login screen and any printed letterhead
 * cannot drift apart.
 *
 * Nothing here is tenant-specific: a hospital's own name, logo and colour come
 * from its `TenantSetting` / branding record at runtime. This is the platform
 * talking about itself.
 */
export const BRANDING = {
    /** Short product name, used in the nav, the footer and page titles. */
    productName: 'HIS',
    /** The long form, used once in the hero and in the `<title>`. */
    productFullName: 'Hospital Information System',
    // TODO(owner): replace tagline — this is a placeholder so the landing page has
    // something honest to say until marketing writes the real one.
    tagline: 'One system for the whole hospital — from the front desk to discharge.',
    shortDescription: 'A multi-tenant hospital information system: OPD, emergency, in-patient, theatre, ' +
        'diagnostics, pharmacy, billing, insurance and the back office, licensed per hospital ' +
        'and isolated per tenant.',
    // TODO(owner): replace with the real contact address.
    contactEmail: 'hello@his.local',
};
//# sourceMappingURL=branding.js.map